import PersistentStore from 'src/services/PersistentStoreService';

const keyReady = (orderId: string) => `orderTracker.readySeenAt.${orderId}`;
const keyAsap = (orderId: string) => `orderTracker.asapSelected.${orderId}`;

export const removeReadySeenAt = async (orderId: string) => {
  try {
    await PersistentStore._delete?.(keyReady(orderId));
  } catch {}
};

export const setAsapSelected = async (orderId: string, isAsap: boolean) => {
  try {
    if (isAsap) {
      await PersistentStore._set?.(keyAsap(orderId), '1');
    } else {
      await PersistentStore._delete?.(keyAsap(orderId));
    }
  } catch {}
};

export const removeAsapFlag = async (orderId: string) => {
  try {
    await PersistentStore._delete?.(keyAsap(orderId));
  } catch {}
};

export const getAsapFlags = async (
  orderIds: string[],
): Promise<Record<string, boolean>> => {
  try {
    const keys = orderIds.map((id) => keyAsap(String(id)));
    const pairs = (await PersistentStore._multiGet?.(keys)) as
      | [string, string][]
      | undefined;
    const map: Record<string, boolean> = {};
    (pairs || []).forEach(([k, v]) => {
      const id = k.replace('orderTracker.asapSelected.', '');
      map[id] = v === '1';
    });
    return map;
  } catch {
    return {};
  }
};
